





































































































import { ProjectsClient, TemplateCompanyPrefixDto, TunnelGroup, TunnelGroupsClient } from '@/data/web-api-client';
import notificationService from '@/services/notificationService';
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';

@Component({
  components: {},
})
export default class ProjectInfo extends Vue {
  @Prop({ required: true })
  project!: any;

  declare date: any;

  tunnelGroups: TunnelGroup[] = [];
  projectTunnelGroupsName: string | undefined = '';
  templateCompanyPrefixes: TemplateCompanyPrefixDto[] = [];
  projectsClient: ProjectsClient = new ProjectsClient(undefined, this.$axios);

  async mounted() {
    await this.loadTunnelGroups();
    await this.getTemplateCompanyPrefixes();
  }

  async loadTunnelGroups() {
    await new TunnelGroupsClient(undefined, this.$axios)
      .get()
      .then((tunnelGroups) => {
        this.tunnelGroups = tunnelGroups;
        this.projectTunnelGroupsName = tunnelGroups.find((dg) => dg.id == this.project.tunnelGroupsId)?.name;
      })
      .catch(() => notificationService.failedToLoad());
  }

  async getTemplateCompanyPrefixes() {
    this.templateCompanyPrefixes = await this.projectsClient.getTemplateCompanyPrefixes();
  }

  get currentCompany() {
    return this.templateCompanyPrefixes.find((tcp) => tcp.prefix === this.project.templateCompanyPrefix)?.displayName;
  }

  get projectStatus() {
    if (!this.project) {
      return '';
    }
    return this.$store.getters['projects/getStatusName'](this.project.status);
  }
}
